<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar />
      <main class="main">
        <breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view />
        </div>
        <Notifications />
      </main>
    </div>
    <AppFooter />
    <Modals />
  </div>
</template>

<script>
import AppHeader from '../components/Header';
import Sidebar from '../components/Sidebar';
import AppFooter from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import Modals from '../components/Modals';
import Notifications from '../components/Notifications';
import config from '../config';

export default {
  name: 'Full',

  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb,
    Modals,
    Notifications,
  },

  computed: {
    list() {
      return this.$route.matched;
    },
  },

  created() {
    const { meta } = this.$route;
    if (Object.prototype.hasOwnProperty.call(meta, 'dontNeedAuth') && meta.dontNeedAuth) return;
    // Actions after correct login
    if (!localStorage.getItem(config.tokenStorage.name) || !localStorage.getItem(config.userStorage.name)) {
      this.$logout();
    } else {
      try {
        // get data from local storage and store it in Vuex
        const user = JSON.parse(localStorage.getItem(config.userStorage.name));
        const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
        this.$store.commit('user/setInfo', user);
        this.$store.commit('user/storeAccessToken', token);
        // Use access token by default for all API requests
        this.$assignAxiosHeaders(token.access_token);
      } catch (error) {
        this.$logout();
      }

      // Get all content types and store it in Vuex store
      this.$apiHttp(`${this.$config.app_api.prefix}content-types/`)
        .then((response) => {
          this.$store.commit('contentTypes/setContentTypesList', response.data);
        }).catch((error) => {
          console.error('Error in get content types query', error);
        });
    }
  },
};
</script>



// WEBPACK FOOTER //
// Full.vue?78733b24